import { render, staticRenderFns } from "./comTooltip.vue?vue&type=template&id=37efcd17&"
import script from "./comTooltip.vue?vue&type=script&lang=js&"
export * from "./comTooltip.vue?vue&type=script&lang=js&"
import style0 from "./comTooltip.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports